import React from 'react'
import { usePageView } from '@fs/zion-analytics'
import { i18n } from '@fs/zion-locale'
import { useEffectiveUser } from '@fs/zion-user'
import { useAamState, useAamInitialization } from '../state/AamStore'
import PageLoadingIndicator from '../../../shared/components/PageLoadingIndicator'
import AAMContent from './AAMContent'
import LanguageWarningDialog from './LanguageWarningDialog/LanguageWarningDialog'

export default function AAMMain() {
  const initData = { page_detail: 'All About Me - Main' }
  usePageView(initData)
  const user = useEffectiveUser() // Using effective user vs user to support helper mode
  const appState = useAamState()

  useAamInitialization(user)

  return appState.isLoading ? (
    <PageLoadingIndicator />
  ) : (
    <>
      <AAMContent tileData={appState.tileData} year={appState.year} user={user} />
      {user.signedIn && (
        <LanguageWarningDialog
          language={i18n.language}
          region={appState.tileData?.[0]?.region}
          year={appState.tileData?.[0]?.year}
        />
      )}
    </>
  )
}
